"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeMetadata = void 0;
const borsh_1 = require("@project-serum/borsh");
const buffer_layout_1 = require("buffer-layout");
const KEY_LAYOUT = borsh_1.rustEnum([
    borsh_1.struct([], 'uninitialized'),
    borsh_1.struct([], 'editionV1'),
    borsh_1.struct([], 'masterEditionV1'),
    borsh_1.struct([], 'reservationListV1'),
    borsh_1.struct([], 'metadataV1'),
    borsh_1.struct([], 'reservationListV2'),
    borsh_1.struct([], 'masterEditionV2'),
    borsh_1.struct([], 'editionMarker'),
]);
const CREATOR_LAYOUT = borsh_1.struct([
    borsh_1.publicKey('address'),
    borsh_1.bool('verified'),
    borsh_1.u8('share'),
]);
const DATA_LAYOUT = borsh_1.struct([
    borsh_1.str('name'),
    borsh_1.str('symbol'),
    borsh_1.str('uri'),
    buffer_layout_1.u16('sellerFeeBasisPoints'),
    borsh_1.option(borsh_1.vec(CREATOR_LAYOUT.replicate('creators')), 'creators')
]);
const METADATA_LAYOUT = borsh_1.struct([
    KEY_LAYOUT.replicate('key'),
    borsh_1.publicKey('updateAuthority'),
    borsh_1.publicKey('mint'),
    DATA_LAYOUT.replicate('data'),
    borsh_1.bool('primarySaleHappened'),
    borsh_1.bool('isMutable'),
    borsh_1.option(borsh_1.u8(), 'editionNonce'),
]);
// eslint-disable-next-line no-control-regex
const METADATA_REPLACE = new RegExp('\u0000', 'g');
function decodeMetadata(buffer) {
    const metadata = METADATA_LAYOUT.decode(buffer);
    metadata.data.name = metadata.data.name.replace(METADATA_REPLACE, '');
    metadata.data.uri = metadata.data.uri.replace(METADATA_REPLACE, '');
    metadata.data.symbol = metadata.data.symbol.replace(METADATA_REPLACE, '');
    return metadata;
}
exports.decodeMetadata = decodeMetadata;
;
//# sourceMappingURL=metadata.js.map